import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgEth48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#E7E7E7",
  d: "M11.973 21.984c5.49-.01 9.932-4.487 9.923-10-.01-5.514-4.467-9.976-9.956-9.967-5.49.009-9.933 4.486-9.923 10 .009 5.513 4.466 9.976 9.956 9.967Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#627EEA",
  d: "M11.973 21.984c5.49-.01 9.932-4.487 9.923-10-.01-5.514-4.467-9.976-9.956-9.967-5.49.009-9.933 4.486-9.923 10 .009 5.513 4.466 9.976 9.956 9.967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.602,
  d: "M11.955 4.502v5.544l4.686 2.093z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11.955 4.502-4.686 7.637 4.686-2.093z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.602,
  d: "M11.955 15.732v3.767l4.689-6.487z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.955 19.499V15.73l-4.686-2.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "m11.955 14.86 4.686-2.72-4.686-2.093z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.602,
  d: "m7.269 12.14 4.686 2.72v-4.813z"
}));

export { SvgEth48Rounded as default };
//# sourceMappingURL=Eth48Rounded.js.map
